import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { CarSearchProvider } from "./context/CarSearchContext"; // 👈 path to the file you just created

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <CarSearchProvider>
        <App />
      </CarSearchProvider>
    </BrowserRouter>
  </React.StrictMode>
);
